export default __webpack_public_path__ + "static/media/move.7d2a4282.svg";